/* eslint-disable no-unused-expressions */

/**
 * Below condition only return true in IE 11
 * reference: https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
 */
// @ts-ignore
if (!!window.MSInputMethodContext && !!document.documentMode) {
  const LOCAL_STORAGE_IE11_ANNOUNCEMENT_KEY = 'isIE11AnnouncementShowed';
  if (!localStorage.getItem(LOCAL_STORAGE_IE11_ANNOUNCEMENT_KEY)) {
    import('../components/Modals/AlertDialog').then((mod) => {
      mod.alertDialog({
        title: 'Support for IE11',
        message:
          'Microsoft will be ending its support of IE on August 17th 2021. After this date OpenLearning will also no longer be supporting your browser',
      });
      localStorage.setItem(LOCAL_STORAGE_IE11_ANNOUNCEMENT_KEY, 'true');
    });
  }
}

/**
 * Todo: Fix old IE warning, this is not working at the moment. Tested on IE8.
 */

if (document.all && !window.atob) {
  import('../topbar/browser-upgrade-warning/browser-upgrade-warning');
}

/**
 * Internet Explorer browser of versions 10 and older can be detected in JavaScript by checking existence of the
 * nonstandard document.all object available only in IE10 and older.
 *
 * document.addEventListener() was first implemented in IE9.
 *
 * Therefore document.all && !document.addEventListener checks whether we are in IE < 9.
 */
if (document.all && !document.addEventListener) {
  import('./isoldie').then((mod) => {
    mod.apply(document.getElementById('very-old-ie-browser-warning'));
  });
} else {
  // Remove empty div since we don't need it
  const elem = document.getElementById('very-old-ie-browser-warning');
  elem.parentNode.removeChild(elem);
}
